export const environment = {
  /**
   * Define a quantidade de linhas a ser exibido na listagem
   */
  LINE_LIMIT: 10,
  /**
   * Placehover dos campos de pesquisa
   */
  SEARCH_INPUT: 'Pesquisar...',
  /**
   * Mensagem da lista caso nao tenha registro
   */
  EMPTY_LIST: 'Nenhum registro encontrado',
  /**
   * URL de acesso a api
   */
  BASE_URL: 'https://backdigital.avaliefacil.com.br',

  /**
   * APP Name
   */
  APP_NAME: '@avalie-finder',
};
